// The single place that answers "does this row need its baseline recomputed?" — for BOTH columns.
// A row that arrived hydrated is satisfied and stays satisfied until something invalidates it.
// One module on purpose: the transient-zero bug shipped half-fixed because the same decision lived in
// two renderers and only one was changed.
import { registerNsbEventResetter } from './nsbEventReset';

const satisfiedFromStorage = new Set<string>();

export const markSatisfiedFromStorage = (sbKey: string): void => {
  if (sbKey) satisfiedFromStorage.add(sbKey);
};

export const needsRecompute = (sbKey: string | null): boolean => (
  !sbKey || !satisfiedFromStorage.has(sbKey)
);

// A new item, a manual entry, a flavor pick, or a rename where the buyer chose "New Baseline".
export const invalidateRow = (sbKey: string | null): void => {
  if (sbKey) satisfiedFromStorage.delete(sbKey);
};

registerNsbEventResetter(() => { satisfiedFromStorage.clear(); });
